// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import impEntity from './entities/imp.json';
import impMenu from '../pages/imp/menu.json';
import impFullForm from '../pages/imp/forms/full.json';
import impContextForm from '../pages/imp/forms/context.json';
import impMiniForm from '../pages/imp/forms/mini.json';
import impLookupForm from '../pages/imp/forms/lookup.json';
import impTableView from '../pages/imp/views/table.json';
import impStagesView from '../pages/imp/views/stages.json';
import impCardsView from '../pages/imp/views/cards.json';
import impInlineView from '../pages/imp/views/inline.json';
import impBacklogView from '../pages/imp/views/backlog.json';
import impSplitView from '../pages/imp/views/split.json';
import impCalendarView from '../pages/imp/views/calendar.json';
import impDashboardView from '../pages/imp/views/dashboard.json';

/** Тип запису «Впровадження» зі сторінками пакета: меню, форми та подання з pages/imp/. */
export const impDefinition: IRecordTypeDefinition = {
  ...impEntity,
  views: assembleViewSet({
      table: impTableView,
      stages: impStagesView,
      cards: impCardsView,
      inline: impInlineView,
      backlog: impBacklogView,
      split: impSplitView,
      calendar: impCalendarView,
      dashboard: impDashboardView,
  }),
  form: impFullForm,
  forms: { full: impFullForm, context: impContextForm, mini: impMiniForm, lookup: impLookupForm },
  menu: impMenu,
} as IRecordTypeDefinition;
